import React, { useEffect, useState } from 'react';
import {
  Button,
} from 'reactstrap';
import { getConsent } from '../../../../services/truststartService';
import Loader from '../../../../components/Loader';

import styles from './SmartSelect.complete.module.scss';

const renderProvider = (label, provider) => (
  <div key={provider.id} className="d-flex justify-content-center">
    <img
      src={provider.logoUrl}
      alt={provider.displayName}
      className={styles.logo}
    />
    <div className={styles.label}>
      {label}
      &nbsp;
      {provider.displayName}
    </div>
  </div>
);

const renderConsentSummary = (consentSummary) => {
  if (!consentSummary) return null;
  const {
    expiresAt,
    dataProvider,
    dataRecipient,
  } = consentSummary;
  if (!dataProvider || !dataRecipient) return null;
  return (
    <div>
      { renderProvider('From', dataProvider) }
      { renderProvider('To', dataRecipient) }
      <div>
        The consent to view your accounts will expire on&nbsp;
        { new Date(expiresAt).toDateString() }
      </div>
      <div />
    </div>
  );
};

export default function SmartSelectComplete({
  handleNextClick,
  scoringRequest,
}) {
  const [consentSummary, setConsentSummary] = useState();
  const [isLoading, setIsLoading] = useState(true);

  const handleFinishButtonClickToPreventDataCloneOfClickEvent = () => handleNextClick();

  useEffect(() => {
    const getConsentSummary = async () => {
      try {
        const result = await getConsent(scoringRequest.clientId, scoringRequest.requestId, 'symcor');
        if (result.errorMessage) {
          // eslint-disable-next-line no-console
          console.error(result.errorMessage);
          return;
        }
        setConsentSummary(result);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error getting consent summary', error);
      } finally {
        setIsLoading(false);
      }
    };
    getConsentSummary();
  }, [scoringRequest.clientId, scoringRequest.requestId]);

  if (isLoading) return (<Loader />);

  return (
    <div>
      <div className="mb-2">
        You have successfully shared read-only access to your accounts.
      </div>
      { renderConsentSummary(consentSummary) }
      <div>
        <Button
          color="success"
          onClick={handleFinishButtonClickToPreventDataCloneOfClickEvent}
        >
          Finish
        </Button>
      </div>
    </div>
  );
}
